"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpacityIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 26" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M4.53247 4.53247C9.2147 -0.149761 16.8061 -0.149761 21.4883 4.53247M4.53247 4.53247C-0.149761 9.2147 -0.149761 16.8061 4.53247 21.4883M4.53247 4.53247L13.0104 13.0104M21.4883 4.53247C26.1706 9.2147 26.1706 16.8061 21.4883 21.4883C16.8061 26.1706 9.2147 26.1706 4.53247 21.4883M21.4883 4.53247L4.53247 21.4883M10.1844 15.8364L2.41299 8.06494M7.35845 18.6624L1 12.3039M15.8364 10.1844L8.06494 2.41299M18.6624 7.35845L12.3039 1", stroke: "black", strokeWidth: "1", fill: fill }, void 0), ";"] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 34" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M5.70996 5.70996C11.9529 -0.533014 22.0748 -0.533014 28.3178 5.70996M5.70996 5.70996C-0.533014 11.9529 -0.533014 22.0748 5.70996 28.3178M5.70996 5.70996L17.0139 17.0139M28.3178 5.70996C34.5607 11.9529 34.5607 22.0748 28.3178 28.3178C22.0748 34.5607 11.9529 34.5607 5.70996 28.3178M28.3178 5.70996L5.70996 28.3178M13.2459 20.7818L2.88398 10.4199M9.47793 24.5498L1 16.0719M20.7818 13.2459L10.4199 2.88398M24.5498 9.47793L16.0719 1", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0) }), void 0));
};
var OpacityIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.OpacityIcon = OpacityIcon;
//# sourceMappingURL=OpacityIcon.js.map